import { VariantProps } from 'class-variance-authority'
import clsx from 'clsx'
import React, { ChangeEvent, HTMLAttributes } from 'react'

import { inputVariants } from '@/components-latest/primitives/Controls/Input'

interface INumericInputProps
  extends Omit<HTMLAttributes<HTMLInputElement>, 'value' | 'onChange'>,
    VariantProps<typeof inputVariants> {
  min?: number
  max?: number
  step?: number
  value: number | null
  onChange: (value: number | null) => void
  disabled?: boolean
  readOnly?: boolean
}

const NumericInput = React.forwardRef<HTMLInputElement, INumericInputProps>(
  (
    {
      className,
      intent = 'default',
      min,
      max,
      step,
      value = null,
      onChange,
      readOnly,
      ...props
    },
    ref
  ) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      if (event.target.value === '') return onChange(null)

      const newValue = parseFloat(event.target.value)

      if (!isNaN(newValue)) {
        onChange(newValue)
      }
    }

    return (
      <input
        data-testid="numeric-input"
        ref={ref}
        type="number"
        min={min}
        max={max}
        step={step}
        value={value?.toString() || ''}
        readOnly={readOnly}
        onChange={handleChange}
        className={clsx(inputVariants({ intent }), className)}
        {...props}
      />
    )
  }
)
NumericInput.displayName = 'NumericInput'

export type { INumericInputProps }
export default NumericInput
